// extracted by mini-css-extract-plugin
export var collapsedSummary = "_oi-0";